import React from 'react'
import AuthenticationContainer from '../containers/AuthenticationProvider/AuthenticationProvider.container'
import TaxesKeyAuthContainer from '../containers/TaxesKeyAuth/TaxesKeyAuth.container'

/**
 * The TaxesKeyAuth' page.
 */
const TaxesKeyAuth = () => {
  return (
    <AuthenticationContainer>
      <TaxesKeyAuthContainer />
    </AuthenticationContainer>
  )
}

export default TaxesKeyAuth
